import { ChangeCatalog } from './../../catalog.model';
import { Component, Inject, OnInit } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DictionaryEntry } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-change-catalog-dialog',
  templateUrl: './change-catalog-dialog.component.html',
  styleUrls: ['./change-catalog-dialog.component.scss']
})
export class ChangeCatalogDialogComponent implements OnInit {

  name = new DictionaryEntry();
  catalogId: number;

  constructor(
    public translationService: TranslationService,
    public dialogRef: MatDialogRef<ChangeCatalogDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private http: HttpService
  ) {
    this.name = data.catalog.name;
    this.catalogId = data.catalog.id;
    // ...



  }

  ngOnInit(): void {
  }

  onClose() {
    this.dialogRef.close();
  }

  onConfirm() {
    console.log('call changeCatalog', this.name);
    this.http.postWithContext<number>(environment.erpCatalogEndpoint + '/changeCatalog', new ChangeCatalog({ catalogId: this.catalogId, name: this.name })).subscribe(response => {

      console.log('response is', response);

      this.dialogRef.close();

    }, error => {
      console.log('error is', error);
    });
  }

  confirmDisabled(): boolean {
    return this.name == null || !this.name.checkValueExistsForLanguage('de');
  }

  public onNameChanged(dictionaryEntry: DictionaryEntry) {
    this.name = dictionaryEntry;
  }

}
